import { MaterialExposureCustomSurveyMeasureItem } from './MaterialExposureCustomSurveyMeasureItem';

export class CustomSurveyMeasuresByCategory {
    categoryId: string;
    measureValues: MaterialExposureCustomSurveyMeasureItem[];

    constructor(categoryId: string, measureValues: MaterialExposureCustomSurveyMeasureItem[]) {
        this.categoryId = categoryId;
        this.measureValues = measureValues;
    }
}
